export default "__VITE_ASSET__1ed92f3f__"